/* ══════════════════════════════════════════════════════════════════
   全站下拉。**接管展开那一层，真 select 一个都不删。**

   原生 select 收起来的样子主题改得动，展开那一层由操作系统画 ——
   深色页脚上会弹出一块系统白底加系统三角。而人看到的正是展开那一层。
   region-picker 早就写下过这条判断，这里把它补到剩下 38 个上。

   底线：真 select 留在表单里，name / value / required / form= 外挂
   一个不动，只是被盖住。选完写回 select.value 再派一个冒泡的 change ——
   sort_by 的「改动即提交」、Shopify 的国家省份联动、生日那两个被 JS
   动态收放的选项，听的都是这个事件，一行都不用改。

   列表**每次打开都重建**，不装 MutationObserver 去盯：
   Shopify 的地址脚本换掉整组 <option> 之后，下次打开自然就是新的。
   只有触发器上那行字需要盯着（换完之后它可能已经不对了），
   那一条用 change ＋ 一个只管 childList 的观察器兜住。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* 超过这个数才给搜索框。250 个国家没有搜索比原生还难用；
     12 个月份配一个搜索框是拿一个空框羞辱人。 */
  var SEARCH_AT = 12;
  var uid = 0;
  var openOne = null;

  /* 文案只有 locale 一个来源 —— JS 里不写死英文。
     EBStrings 在 theme.liquid 里由 Liquid 填好（见那里的注释）。
     **用的时候才读，不在这一行就锁死**：这个文件是 defer 加载的，
     线上顺序是稳的，但设计稿和任何「先加载脚本再填文案」的场合里，
     锁死拿到的是一个空对象，然后搜索框就没有占位符了。 */
  function T() { return (window.EBStrings && window.EBStrings.picker) || {}; }

  var CARET = '<svg class="eb-picker__caret" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 9 7 7 7-7"/></svg>';
  var TICK = '<svg class="eb-picker__tick" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4 12 5.5 5.5L20 7"/></svg>';
  var GLASS = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4 4"/></svg>';

  function isSheet() { return window.matchMedia('(max-width: 768px)').matches; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function build(sel) {
    if (sel.closest('.eb-picker') || sel.multiple || sel.size > 1) return;

    var id = 'ebp' + (++uid);
    var wrap = document.createElement('div');
    wrap.className = 'eb-picker';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('eb-picker__native');
    /* 真 select 退出 Tab 序：**不然 Tab 会在同一个字段上停两次** ——
       一次落在看不见的它身上，人以为焦点丢了。 */
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    /* **把原来那个 select 的 class 一起搬到触发器上。**
       全站大部分下拉是 .eb-select（默认那身），但集合页/搜索页的排序是
       .eb-sort —— 药丸形、左边还有个图标、内边距完全不同。不搬的话，
       那个控件会在改版当天变成一个方框。
       搬过来之后 .eb-sort 排在 base.css 后面，同权重后来者胜，
       它自然盖住触发器的默认那身。 */
    trigger.className = ('eb-picker__trigger ' + sel.className).replace(/\beb-picker__native\b/g, '').trim();
    trigger.id = id + '-t';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    /* 名字从原来那个 select 上原样搬过来 —— aria-label，或者它自己的
       <label for>，或者包着它的那个 <label>。搬不过来的话读屏器念出来的
       是一个没有名字的按钮。

       **包着控件的 <label> 不能直接拿它的 textContent** ——
       那里面连所有 <option> 的字一起算进去，读屏器会把整份国家名单
       当成这个字段的名字念一遍。这个主题的表单标签都在
       `.eb-field__label` 里，优先指它；没有的话克隆一份把控件删掉再取字。 */
    var name = sel.getAttribute('aria-label') || '';
    if (name) trigger.setAttribute('aria-label', name);
    else {
      var tag = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
      if (!tag) tag = sel.closest('label');
      if (tag) {
        var span = tag.querySelector('.eb-field__label');
        if (span) {
          if (!span.id) span.id = id + '-l';
          trigger.setAttribute('aria-labelledby', span.id);
          name = span.textContent.trim();
        } else {
          var clone = tag.cloneNode(true);
          Array.prototype.forEach.call(clone.querySelectorAll('select, input, textarea, button'), function (n) { n.parentNode.removeChild(n); });
          name = clone.textContent.replace(/\s+/g, ' ').trim();
          if (name) trigger.setAttribute('aria-label', name);
        }
      }
    }
    wrap.appendChild(trigger);

    var panel = null;
    var scrim = null;
    var active = -1;
    var shown = [];

    function paintTrigger() {
      var o = sel.options[sel.selectedIndex];
      var text = o ? o.text.trim() : '';
      trigger.innerHTML = '<span class="eb-picker__value"></span>' + CARET;
      trigger.firstChild.textContent = text;
      /* 没选东西时和 ::placeholder 一个颜色：「Month」和「you@email.com」
         是同一种字 —— 它们都是提示，不是答案。 */
      trigger.classList.toggle('is-empty', !o || o.value === '');
    }

    function rows(filter) {
      var q = (filter || '').trim().toLowerCase();
      shown = [];
      var html = '';
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (o.hidden) continue;
        /* 没有文字的占位项不画：原生 select 里 `<option value="">` 常常
           是空的（收起来的时候本来就该是空的），照画会在列表最上面留一条
           **看不出是什么的空行**，而空行看起来像组件坏了。
           有文字的占位项（「Month」）照画 —— 那是选填字段清空的唯一出口。 */
        if (!o.text.trim()) continue;
        if (q && o.text.toLowerCase().indexOf(q) === -1) continue;
        var on = i === sel.selectedIndex;
        shown.push(i);
        html += '<li role="option" id="' + id + '-o' + i + '"'
          + ' class="eb-picker__opt' + (on ? '' : '') + '"'
          + ' aria-selected="' + (on ? 'true' : 'false') + '"'
          + (o.disabled ? ' aria-disabled="true"' : '')
          + ' data-i="' + i + '">'
          + '<span class="eb-picker__optname">' + esc(o.text.trim()) + '</span>'
          + (on ? TICK : '')
          + '</li>';
      }
      if (!html) html = '<p class="eb-picker__empty">' + esc(T().empty || '') + '</p>';
      return html;
    }

    function open() {
      if (panel) return;
      if (openOne && openOne !== close) openOne();

      /* 数的是**真选项**：占位那条（value 为空的「Month」）和被藏起来的
         都不算。12 个月份加一条占位就是 13，按 length 数会给月份配一个
         空搜索框 —— 那个框只会让人以为月份列表长到需要搜。 */
      var real = 0;
      for (var n = 0; n < sel.options.length; n++) {
        if (!sel.options[n].hidden && sel.options[n].value !== '') real++;
      }
      var many = real > SEARCH_AT;
      panel = document.createElement('div');
      panel.className = 'eb-picker__panel';
      panel.id = id + '-p';
      panel.innerHTML =
        '<div class="eb-picker__grab"></div>'
        + '<p class="eb-picker__head">' + esc(name) + '</p>'
        + (many ? '<div class="eb-picker__search">' + GLASS + '<input type="text" autocomplete="off" spellcheck="false" placeholder="' + esc(T().search || '') + '" aria-label="' + esc(T().search || '') + '"></div>' : '')
        + '<ul class="eb-picker__list" role="listbox" tabindex="-1" aria-labelledby="' + trigger.id + '">' + rows('') + '</ul>';

      /* 往上还是往下：**这里必须量**。region-picker 不量是因为它的答案
         固定（公告条在顶、页脚在底）；表单里的下拉可能在任何高度，
         一个开在视口外的面板等于没开。 */
      var box = trigger.getBoundingClientRect();
      var need = Math.min(340, real * 34 + (many ? 62 : 24));
      wrap.classList.toggle('eb-picker--up', !isSheet() && box.bottom + need > window.innerHeight && box.top > need);

      if (isSheet()) {
        scrim = document.createElement('div');
        scrim.className = 'eb-picker__scrim';
        document.body.appendChild(scrim);
        scrim.addEventListener('click', close);
        document.body.appendChild(panel);
      } else {
        wrap.appendChild(panel);
      }

      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-controls', panel.id);
      openOne = close;

      panel.addEventListener('keydown', onKey);
      var list = panel.querySelector('.eb-picker__list');
      list.addEventListener('click', onPick);
      list.addEventListener('mousemove', onHover);
      var search = panel.querySelector('input');
      if (search) {
        search.addEventListener('input', function () {
          list.innerHTML = rows(search.value);
          setActive(shown.length ? 0 : -1, true);
        });
        /* 手机上不自动聚焦搜索框：键盘一弹，抽屉只剩一条缝。
           和订阅浮层那条规矩同一条。 */
        if (!isSheet()) search.focus();
        else list.focus();
      } else if (isSheet()) list.focus();
      setActive(Math.max(0, shown.indexOf(sel.selectedIndex)), true);
      document.addEventListener('mousedown', onOutside, true);
    }

    function close(refocus) {
      if (!panel) return;
      document.removeEventListener('mousedown', onOutside, true);
      panel.remove(); panel = null;
      if (scrim) { scrim.remove(); scrim = null; }
      wrap.classList.remove('is-open', 'eb-picker--up');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.removeAttribute('aria-controls');
      openOne = null;
      if (refocus === true) trigger.focus();
    }

    function onOutside(e) { if (!wrap.contains(e.target) && (!panel || !panel.contains(e.target))) close(); }

    function setActive(n, scroll) {
      if (!panel) return;
      var items = panel.querySelectorAll('.eb-picker__opt');
      for (var i = 0; i < items.length; i++) items[i].classList.remove('is-active');
      active = n;
      var el = items[n];
      if (!el) { panel.querySelector('.eb-picker__list').removeAttribute('aria-activedescendant'); return; }
      el.classList.add('is-active');
      panel.querySelector('.eb-picker__list').setAttribute('aria-activedescendant', el.id);
      if (scroll) el.scrollIntoView({ block: 'nearest' });
    }

    function onHover(e) {
      var li = e.target.closest('.eb-picker__opt');
      if (!li) return;
      var items = Array.prototype.slice.call(panel.querySelectorAll('.eb-picker__opt'));
      setActive(items.indexOf(li), false);
    }

    function onPick(e) {
      var li = e.target.closest('.eb-picker__opt');
      if (!li || li.getAttribute('aria-disabled') === 'true') return;
      choose(+li.dataset.i);
    }

    function choose(i) {
      sel.selectedIndex = i;
      paintTrigger();
      close(true);
      /* **这一下是全部的接口。** 现有代码听的就是 change：
         sort_by 的自动提交、Shopify 的省份联动、生日那两格的收放。
         少派这个事件，上面每一样都会静默失灵。 */
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function step(d) {
      if (!panel) { open(); return; }
      var items = panel.querySelectorAll('.eb-picker__opt');
      if (!items.length) return;
      var n = active;
      for (var k = 0; k < items.length; k++) {
        n = (n + d + items.length) % items.length;
        if (items[n].getAttribute('aria-disabled') !== 'true') break;
      }
      setActive(n, true);
    }

    trigger.addEventListener('click', function () { panel ? close(true) : open(); });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); step(e.key === 'ArrowDown' ? 1 : -1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); panel ? close(true) : open(); }
    });
    /* 键盘处理**挂两处**：wrap（焦点在触发器上时）和 panel 自己。
       手机那一档面板是挂到 body 上的，不在 wrap 里 —— 只挂 wrap 的话，
       焦点一旦进了列表，Esc 和上下键就都失灵了。 */
    function onKey(e) {
      if (!panel) return;
      if (e.key === 'Escape') { e.preventDefault(); close(true); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); step(-1); }
      else if (e.key === 'Home') { e.preventDefault(); setActive(0, true); }
      else if (e.key === 'End') { e.preventDefault(); setActive(panel.querySelectorAll('.eb-picker__opt').length - 1, true); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        var el = panel.querySelectorAll('.eb-picker__opt')[active];
        if (el && el.getAttribute('aria-disabled') !== 'true') choose(+el.dataset.i);
      }
      else if (e.key === 'Tab') close();
    }
    wrap.addEventListener('keydown', onKey);

    /* 外面改了这个 select 就重画那行字。两条来源：
       派了 change 的（我们自己、大部分脚本），和整组换掉 <option>
       不派事件的（Shopify 的省份联动就是这一种）。 */
    sel.addEventListener('change', paintTrigger);
    if (window.MutationObserver) new MutationObserver(paintTrigger).observe(sel, { childList: true });

    paintTrigger();
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('select:not([data-eb-picker="off"])');
    Array.prototype.forEach.call(list, build);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });

  /* 编辑器里换了 section、或者哪个 section 自己重画了一段 HTML，
     新出现的 select 也要接管。 */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  window.EBPicker = { scan: scan };
})();
